import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DigitalSystems = () => (
  <QPhototModuleSubtopic
    title="Digital Systems"
    videos={[
      "https://www.youtube.com/embed/FFDMzbrEXaE",
      "https://www.youtube.com/embed/s9kwJ03uzmE"
    ]}
    takeaways={[
      { text: "Practice all models of conversion from decimal to binary, binary to octal and hexadecimal and vice versa." },
      { text: "Number base conversions." }
    ]}
    questions={[
      { image: "/beee_36.jpeg" },
      { image: "/beee_37.jpeg" },
      { image: "/beee_38.jpeg" },
      { image: "/beee_39.jpeg" },
      { image: "/beee_40.jpeg" },
      { image: "/beee_41.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default DigitalSystems;
